(function () {
  'use strict';

  if (window.PGCartSingleCheckoutV18) return;
  window.PGCartSingleCheckoutV18 = true;

  var ROOT_SELECTOR = [
    '.cart_content',
    '#pg-cart',
    '.ecom-ajax-cart',
    '.mini-cart',
    '.side-cart',
    '.cart-drawer',
    '[data-cart-drawer]',
    '[data-cart-content]'
  ].join(',');

  var CONTROL_SELECTOR = [
    'a',
    'button',
    'input[type="submit"]',
    'input[type="button"]',
    '[role="button"]'
  ].join(',');

  var observer = null;
  var timer = null;

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function labelOf(control) {
    return normalise([
      control.value,
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.innerText,
      control.textContent
    ].filter(Boolean).join(' '));
  }

  function attributeText(control) {
    var values = [control.id || '', typeof control.className === 'string' ? control.className : ''];
    Array.prototype.forEach.call(control.attributes || [], function (attribute) {
      values.push(attribute.name || '', attribute.value || '');
    });
    return normalise(values.join(' '));
  }

  function isExcluded(control) {
    var label = labelOf(control);
    var attrs = attributeText(control);
    var href = normalise(control.getAttribute('href'));

    if (/continue without|continue shopping|view cart|keep shopping|remove|delete|close cart|apple pay|google pay|shop pay|paypal|klarna|amazon pay/.test(label)) return true;
    if (/quantity|remove|delete|drawer-close|close-button|dynamic-checkout|additional-checkout/.test(attrs)) return true;
    if (/continue_shopping|\/cart(?:$|\?)/.test(href)) return true;
    return false;
  }

  function isCheckoutCandidate(control) {
    if (isExcluded(control)) return false;

    var label = labelOf(control);
    var attrs = attributeText(control);
    var href = normalise(control.getAttribute('href'));
    var name = normalise(control.getAttribute('name'));

    return /checkout|secure checkout|complete order|continue to payment|proceed to payment|pay now/.test(label) ||
      /checkout|onward|checkoutplus|checkout-plus/.test(attrs) ||
      /\/checkout(?:$|\?|\/)/.test(href) ||
      name === 'checkout';
  }

  function isOnward(control) {
    var label = labelOf(control);
    var attrs = attributeText(control);

    return /checkout\s*\+|checkoutplus|checkout-plus/.test(label) ||
      /onward|checkoutplus|checkout-plus|checkout_plus/.test(attrs);
  }

  function isNativeThemeCheckout(control) {
    return Boolean(
      control &&
      control.matches &&
      control.matches('[data-minicart-checkout-button], .pg-cart__checkout-btn, [data-pg-uk-native-generated="true"]')
    );
  }

  function reconcileOnwardOptOut(root) {
    Array.prototype.forEach.call(root.querySelectorAll(CONTROL_SELECTOR), function (control) {
      if (control.matches && control.matches('a.pg-drawer-standard-checkout')) {
        control.classList.remove('pg-onward-optout-link');
        control.removeAttribute('data-pg-onward-optout');
        return;
      }
      var isOptOut = /continue without/.test(labelOf(control));
      var wasOptOut = control.getAttribute('data-pg-onward-optout') === 'true';

      if (isOptOut) {
        control.classList.add('pg-onward-optout-link');
        control.setAttribute('data-pg-onward-optout', 'true');
      } else if (wasOptOut) {
        control.classList.remove('pg-onward-optout-link');
        control.removeAttribute('data-pg-onward-optout');
      }
    });
  }

  function isPotentiallyVisible(control) {
    if (!control || control.hidden) return false;
    if (control.getAttribute('aria-hidden') === 'true' && !control.classList.contains('pg-cart-checkout-duplicate-v18')) return false;

    var style = window.getComputedStyle(control);
    if (style.display === 'none' && !control.classList.contains('pg-cart-checkout-duplicate-v18')) return false;
    if (style.visibility === 'hidden' && !control.classList.contains('pg-cart-checkout-duplicate-v18')) return false;
    return true;
  }

  function score(control, root) {
    var value = 0;
    var label = labelOf(control);
    var attrs = attributeText(control);
    var href = normalise(control.getAttribute('href'));
    var rect = control.getBoundingClientRect();
    var rootWidth = root.getBoundingClientRect().width || 1;

    if (isOnward(control)) value += 200;
    if (/checkout\s*\+/.test(label)) value += 80;
    if (/onward/.test(attrs)) value += 60;
    if (/secure/.test(label)) value += 25;
    if (/\/checkout/.test(href)) value += 15;
    if (rect.width >= rootWidth * 0.7) value += 10;
    return value;
  }

  function clearMarks(root) {
    root.querySelectorAll('.pg-cart-checkout-primary-v18, .pg-cart-checkout-duplicate-v18').forEach(function (control) {
      control.classList.remove('pg-cart-checkout-primary-v18', 'pg-cart-checkout-duplicate-v18');
      control.removeAttribute('data-pg-cart-primary-action');
      if (control.getAttribute('data-pg-v18-aria-hidden') === 'true') {
        control.removeAttribute('aria-hidden');
        control.removeAttribute('data-pg-v18-aria-hidden');
      }
      if (control.getAttribute('data-pg-v18-tabindex') === 'true') {
        control.removeAttribute('tabindex');
        control.removeAttribute('data-pg-v18-tabindex');
      }
    });
    root.classList.remove('pg-cart-has-onward-v18');
  }

  function markDuplicates(controls, primary, secondary) {
    primary.classList.add('pg-cart-checkout-primary-v18');

    controls.forEach(function (control) {
      if (control === primary || control === secondary) return;
      control.classList.add('pg-cart-checkout-duplicate-v18');
      control.setAttribute('aria-hidden', 'true');
      control.setAttribute('data-pg-v18-aria-hidden', 'true');
      control.setAttribute('tabindex', '-1');
      control.setAttribute('data-pg-v18-tabindex', 'true');
    });
  }

  function reconcileRoot(root) {
    if (!root) return;

    // Drawer only, and only if the separate ordinary-checkout link exists.
    // Remove Onward's redundant opt-out button. Its empty underline and
    // surrounding margin were appearing above the actual checkout link.
    if (root.matches && root.matches('.cart_content') &&
        root.querySelector('a.pg-drawer-standard-checkout[href="/checkout"]')) {
      root.querySelectorAll('button.onward-opt-out-link').forEach(function (button) {
        button.remove();
      });
    }

    clearMarks(root);
    reconcileOnwardOptOut(root);

    var controls = Array.prototype.filter.call(root.querySelectorAll(CONTROL_SELECTOR), function (control) {
      return isPotentiallyVisible(control) && isCheckoutCandidate(control);
    });

    if (controls.length < 2) return;

    var onwardControls = controls.filter(isOnward);
    var nativeControls = controls.filter(isNativeThemeCheckout);
    if (onwardControls.length) {
      onwardControls.sort(function (left, right) {
        return score(right, root) - score(left, root);
      });

      var onwardPrimary = onwardControls[0];
      root.classList.add('pg-cart-has-onward-v18');
      onwardPrimary.setAttribute('data-pg-cart-primary-action', 'onward-v18');
      markDuplicates(controls, onwardPrimary);
      return;
    }

    if (!nativeControls.length) return;

    var nativePrimary = nativeControls[0];
    nativePrimary.setAttribute('data-pg-cart-primary-action', 'native-v18');
    markDuplicates(controls, nativePrimary);
  }

  function reconcileAll() {
    timer = null;
    document.querySelectorAll(ROOT_SELECTOR).forEach(reconcileRoot);
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcileAll, delay == null ? 20 : delay);
  }

  function boot() {
    reconcileAll();

    document.addEventListener('cart:refresh', function () { schedule(20); });
    document.addEventListener('pg:cart-form-patched', function () { schedule(20); });
    document.addEventListener('shopify:cart:lines-update', function () { schedule(40); });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest(ROOT_SELECTOR)) schedule(80);
    }, true);

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(function (mutations) {
        var touchesCart = mutations.some(function (mutation) {
          var target = mutation.target && mutation.target.nodeType === 1
            ? mutation.target
            : mutation.target && mutation.target.parentElement;

          if (target && target.closest && target.closest(ROOT_SELECTOR)) return true;

          return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
            return node.nodeType === 1 && (
              node.matches && node.matches(ROOT_SELECTOR) ||
              node.querySelector && node.querySelector(ROOT_SELECTOR)
            );
          });
        });

        if (touchesCart) schedule(20);
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    [100, 350, 800, 1600, 3200, 6000].forEach(function (delay) {
      window.setTimeout(reconcileAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
